/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './article.component.scss.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '../shared/sticky-header/sticky-header.component.ngfactory';
import * as import3 from '../../../app/shared/sticky-header/sticky-header.component';
import * as import4 from '@angular/common';
import * as import5 from './articlecontent/articlecontent.component.ngfactory';
import * as import6 from '../../../app/article/articlecontent/articlecontent.component';
import * as import7 from '../../../app/shared/services/stringutils';
import * as import8 from '../../../app/shared/type-builder/type.builder';
import * as import9 from '../shared/decorator/header/header.component.ngfactory';
import * as import10 from '../../../app/shared/decorator/header/header.component';
import * as import11 from '../../../app/article/article.component';
import * as import12 from 'angular2-infinite-scroll/src/infinite-scroll';
import * as import13 from 'angular2-infinite-scroll/src/position-resolver';
import * as import14 from 'angular2-infinite-scroll/src/scroll-register';
import * as import15 from 'angular2-infinite-scroll/src/scroll-resolver';
import * as import16 from '../shared/menu/menu.component.ngfactory';
import * as import17 from '../../../app/shared/menu/menu.component';
import * as import18 from '../../../modules/transfer-state/transfer-state';
import * as import19 from '../../../../common/utils/costguideutils';
import * as import20 from '@angular/router';
import * as import21 from '../../../../common/utils/articleutils';
import * as import22 from '@angular/platform-browser';
import * as import23 from '../../../app/shared/animations/hero-animation.service';
const styles_ArticleComponent:any[] = [import0.styles];
export const RenderType_ArticleComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 2,
  styles: styles_ArticleComponent,
  data: {}
}
);
function View_ArticleComponent_1(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),6,'stickyHeader',([] as any[]),(null as any),[[
        'window',
        'scroll'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('window:scroll' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,1).onScroll($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import2.View_StickyHeaderComponent_0,import2.RenderType_StickyHeaderComponent)),
    import1.ɵdid(49152,[
      [
        1,
        4
      ]
      ,
      [
        'stickyHeader',
        4
      ]

    ]
    ,0,import3.StickyHeaderComponent,[import4.Location],{
      url: [
        0,
        'url'
      ]
      ,
      title: [
        1,
        'title'
      ]
      ,
      twitterText: [
        2,
        'twitterText'
      ]
      ,
      ogTitle: [
        3,
        'ogTitle'
      ]
      ,
      ogDescription: [
        4,
        'ogDescription'
      ]

    }
    ,(null as any)),
    import1.ɵpid(131072,import4.AsyncPipe,[import1.ChangeDetectorRef]),
    import1.ɵpid(131072,import4.AsyncPipe,[import1.ChangeDetectorRef]),
    import1.ɵpid(131072,import4.AsyncPipe,[import1.ChangeDetectorRef]),
    import1.ɵpid(131072,import4.AsyncPipe,[import1.ChangeDetectorRef]),
    import1.ɵpid(131072,import4.AsyncPipe,[import1.ChangeDetectorRef])
  ]
  ,(ck,v) => {
    var co:any = v.component;
    var tmp_0_0:any = (null as any);
    const currVal_0:any = (((tmp_0_0 = import1.ɵunv(v,1,0,import1.ɵnov(v,2).transform(co.articleView))) == null)? (null as any): tmp_0_0.url);
    var tmp_1_0:any = (null as any);
    const currVal_1:any = (((tmp_1_0 = import1.ɵunv(v,1,1,import1.ɵnov(v,3).transform(co.articleView))) == null)? (null as any): tmp_1_0.title);
    var tmp_2_0:any = (null as any);
    const currVal_2:any = (((tmp_2_0 = import1.ɵunv(v,1,2,import1.ɵnov(v,4).transform(co.articleView))) == null)? (null as any): tmp_2_0.twitterText);
    var tmp_3_0:any = (null as any);
    const currVal_3:any = (((tmp_3_0 = import1.ɵunv(v,1,3,import1.ɵnov(v,5).transform(co.articleView))) == null)? (null as any): tmp_3_0.ogTitle);
    var tmp_4_0:any = (null as any);
    const currVal_4:any = (((tmp_4_0 = import1.ɵunv(v,1,4,import1.ɵnov(v,6).transform(co.articleView))) == null)? (null as any): tmp_4_0.ogDescription);
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4);
  },(null as any));
}
function View_ArticleComponent_2(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),26,'div',[
      [
        'class',
        'd-flex flex-column'
      ]
      ,
      [
        'style',
        'padding-bottom: 50px;'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),23,'div',[[
        'class',
        'article-container'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),20,'div',[[
        'class',
        'row previous-article-content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n              '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'col-lg col-md'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n              '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'col-lg-8 col-md-12 previous-article-content'
      ]
      ],[[
        8,
        'id',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'articlecontent',([] as any[]),(null as any),[[
        (null as any),
        'onVisible'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onVisible' === en)) {
        const pd_0:any = ((<any>co.changeActiveArticle($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import5.View_ArticleContentComponent_0,import5.RenderType_ArticleContentComponent)),
    import1.ɵdid(4374528,(null as any),0,import6.ArticleContentComponent,[
      import7.StringUtils,
      import8.DynamicTypeBuilder,
      'isBrowser'
    ]
      ,{article: [
        0,
        'article'
      ]
    },{onVisible: 'onVisible'}),
    (l()(),import1.ɵted((null as any),['\n                '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'article-bottom-gradient'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'a',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.showArticle(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'read-more'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                    Read Full Story\n                  '])),
    (l()(),import1.ɵted((null as any),['\n                  '])),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵted((null as any),['\n              '])),
    (l()(),import1.ɵted((null as any),['\n              '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'col-lg col-md'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    const currVal_1:any = v.context.$implicit;
    ck(v,11,0,currVal_1);
  },(ck,v) => {
    const currVal_0:any = import1.ɵinlineInterpolate(1,'',v.context.$implicit.id,'_container');
    ck(v,8,0,currVal_0);
  });
}
export function View_ArticleComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    import1.ɵqud(671088640,1,{stickyHeader: 0}),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ArticleComponent_1)),
    import1.ɵdid(16384,(null as any),0,import4.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'header',([] as any[]),(null as any),(null as any),(null as any),import9.View_HeaderComponent_0,import9.RenderType_HeaderComponent)),
    import1.ɵdid(49152,(null as any),0,import10.HeaderComponent,([] as any[]),(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n\n'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),37,'div',[
      [
        'class',
        'menu-perspective effect-moveright'
      ]
      ,
      [
        'id',
        'menu-perspective'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),31,'div',[[
        'class',
        'menu-container'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),28,'div',[[
        'class',
        'menu-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n\n      '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),25,'div',[
      [
        'class',
        'container'
      ]
      ,
      [
        'id',
        'article'
      ]
      ,
      [
        'infinite-scroll',
        ''
      ]

    ]
      ,(null as any),[[
        (null as any),
        'scrolled'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import11.ArticleComponent = v.component;
      if (('scrolled' === en)) {
        const pd_0:any = ((<any>co.renderPreviousArticle()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(212992,(null as any),0,import12.InfiniteScroll,[
      import1.ElementRef,
      import1.NgZone,
      import13.PositionResolverFactory,
      import14.ScrollRegister,
      import15.ScrollResolver
    ]
    ,{
      _distanceDown: [
        0,
        '_distanceDown'
      ]
      ,
      _throttle: [
        1,
        '_throttle'
      ]

    }
    ,{scrolled: 'scrolled'}),
    (l()(),import1.ɵted((null as any),['\n\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),18,'div',[
      [
        'class',
        'd-flex flex-column'
      ]
      ,
      [
        'style',
        'padding-bottom: 50px;'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),15,'div',[[
        'class',
        'article-container'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),12,'div',[[
        'class',
        'row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n              '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'col-lg col-md'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n              '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),5,'div',[[
        'class',
        'col-lg-8 col-md-12 article-content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),2,'articlecontent',([] as any[]),(null as any),[[
        (null as any),
        'onVisible'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import11.ArticleComponent = v.component;
      if (('onVisible' === en)) {
        const pd_0:any = ((<any>co.changeActiveArticle($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import5.View_ArticleContentComponent_0,import5.RenderType_ArticleContentComponent)),
    import1.ɵdid(4374528,(null as any),0,import6.ArticleContentComponent,[
      import7.StringUtils,
      import8.DynamicTypeBuilder,
      'isBrowser'
    ]
      ,{article: [
        0,
        'article'
      ]
    },{onVisible: 'onVisible'}),
    import1.ɵpid(131072,import4.AsyncPipe,[import1.ChangeDetectorRef]),
    (l()(),import1.ɵted((null as any),['\n              '])),
    (l()(),import1.ɵted((null as any),['\n              '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'col-lg col-md'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵted((null as any),['\n\n        '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ArticleComponent_2)),
    import1.ɵdid(802816,(null as any),0,import4.NgForOf,[
      import1.ViewContainerRef,
      import1.TemplateRef,
      import1.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n\n      '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'menu',([] as any[]),(null as any),(null as any),(null as any),import16.View_MenuComponent_0,import16.RenderType_MenuComponent)),
    import1.ɵdid(4243456,(null as any),0,import17.MenuComponent,[
      'isBrowser',
      import18.TransferState,
      import19.CostGuideUtils
    ]
    ,(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import11.ArticleComponent = v.component;
    const currVal_0:any = co.showStickyHeader;
    ck(v,2,0,currVal_0);
    const currVal_1:any = 2;
    const currVal_2:any = 300;
    ck(v,14,0,currVal_1,currVal_2);
    const currVal_3:any = import1.ɵunv(v,27,0,import1.ɵnov(v,28).transform(co.articleView));
    ck(v,27,0,currVal_3);
    const currVal_4:any = co.previousArticles;
    ck(v,37,0,currVal_4);
  },(null as any));
}
function View_ArticleComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'articleComponent',([] as any[]),(null as any),(null as any),(null as any),View_ArticleComponent_0,RenderType_ArticleComponent)),
    import1.ɵdid(4243456,(null as any),0,import11.ArticleComponent,[
      import20.ActivatedRoute,
      import21.ArticleUtils,
      import22.Meta,
      import22.Title,
      import18.TransferState,
      import23.HeroAnimationService,
      import4.Location
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const ArticleComponentNgFactory:import1.ComponentFactory<import11.ArticleComponent> = import1.ɵccf('articleComponent',import11.ArticleComponent,View_ArticleComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/ngfactory/app/article/article.component.ngfactory.ts